<div class="modal-header">
  <h4 class="modal-title">Close report</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    [disabled]="loading"
    (click)="activeModal.dismiss()">
  </button>
</div>
<div class="modal-body">
  <p>
    Have you found {{ pet.name }}?
  </p>
  <button type="button"
          class="btn btn-link p-0"
          (click)="toggleReportStatus()">
    <fa-icon [icon]="['far', reportStatus === petMissingReportStatus.ClosedDeceased ? 'check-square' : 'square']"></fa-icon>
    Unfortunately my pet has passed away
  </button>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-success text-white"
    [disabled]="loading"
    (click)="submit()">
    {{ loading ? 'Updating...' : 'Yes' }}
  </button>
  <button
    type="button"
    class="btn btn-danger text-white"
    ngbAutofocus
    [disabled]="loading"
    (click)="activeModal.dismiss()">
    Go back
  </button>
</div>
